module.exports = __webpack_public_path__ + "img/level12.aeb7dd62.png";